import PrintPage from './PrintPage'

export default PrintPage
